import { Component } from '@angular/core';
import { MenuItem} from 'primeng/api';
import { ActivatedRoute, Router } from "@angular/router";
import { DataService } from '../data.service';

@Component({
  selector: 'app-selectorformulario',
  templateUrl: './selectorformulario.component.html',
  styleUrls: ['./selectorformulario.component.css']
})

export class SelectorformularioComponent {
 formularios;
 opciones = [
  { label: 'Opción 1', value: '1' },
  { label: 'Opción 2', value: '2' },
  { label: 'Opción 3', value: '3' }
];
opcionSeleccionada: any = null;

  constructor(public data: DataService, private route: ActivatedRoute, private router: Router) {
    this.opcionSeleccionada = this.route.snapshot.paramMap.get('id');

    this.data.ObtenerFormularios().subscribe(x => {
      this.formularios = x;
      //obtener opciones de formularios para cargar el objeto opciones con value=_id y label=nombre
      this.opciones = this.formularios.map((x) => {
        return { label: x.Definicion.title, value: x._id }
      });
      console.log("================opciones================");
      console.log(this.opciones );
    })
  }
  navigateToFormulario(id: string) {
    //this.router.navigate(['/formulario', id]);
    window.location.href = `/formulario/${id}`;
  }

  onSeleccionarOpcion(event) {
    window.location.href = `/formulario/${event.value}`;
    //this.router.navigate(['/formulario', event.value]);
  }


}